module.exports = __webpack_public_path__ + "img/doctor.a8e3bcb9.svg";